import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'

import { cn } from '../../lib/utils'

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

const FancyProgress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & { isDestructive?: boolean }
>(({ className, value, isDestructive, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'relative h-8 w-full overflow-hidden rounded-full bg-white border border-gray-200 flex items-center px-2',
        className,
      )}
      {...props}
    >
      <div className="w-full rounded-full overflow-hidden">
        <ProgressPrimitive.Indicator
          className={cn(
            'h-[19px] w-full flex-1 bg-main transition-all rounded-full',
            isDestructive && 'bg-destructive',
          )}
          style={{
            transform: `translateX(-${100 - Math.min((value || 0) + 5, 100)}%)`,
            boxShadow: isDestructive
              ? 'inset 4px 6px 5px #faececd9'
              : 'inset 4px 6px 5px rgba(188, 209, 255, 1)',
          }}
        />
      </div>
    </ProgressPrimitive.Root>
  )
})
FancyProgress.displayName = ProgressPrimitive.Root.displayName

export { Progress, FancyProgress }
